import { i18n } from '@/locales';
import { brgChipColorMapper } from '@/components/Common/Chip.vue';
import { convertCase } from '@/utils';
const lc = 'views.tax_invoice.status_type_option.';
/* eslint-disable import/prefer-default-export */
export const taxInvoiceStatus = {
    NONE: 'NONE', // 없음
    DRAFT: 'DRAFT', // 임시저장
    PUBLISH_REQUESTED: 'PUBLISH_REQUESTED', // 발행요청(역발행)
    PUBLISH_COMPLETED: 'PUBLISH_COMPLETED', // 발행완료
    TRANSFER_BEFORE: 'TRANSFER_BEFORE', // 전송전
    TRANSFER_WAITED: 'TRANSFER_WAITED', // 전송대기
    TRANSFER_IN_PROGRESSED: 'TRANSFER_IN_PROGRESSED', // 전송중
    TRANSFER_COMPLETED: 'TRANSFER_COMPLETED', // 전송성공
    TRANSFER_FAILED: 'TRANSFER_FAILED', // 전송실패
    PUBLISH_REQUEST_REJECTED: 'PUBLISH_REQUEST_REJECTED', // 발행요청(역발행) 거부
    PUBLISH_REQUEST_CANCELED: 'PUBLISH_REQUEST_CANCELED', // 발행요청(역발행) 취소
    PUBLISH_REQUEST_FAILED: 'PUBLISH_REQUEST_FAILED', // 발행요청(역발행) 실패
    PUBLISH_CANCELED: 'PUBLISH_CANCELED', // 발행 취소
};
export const taxInvoiceStatusChipMapper = (type) => {
    const typeText = convertCase(type, 'enum', 'snake');
    // https://www.notion.so/barogohq/P2-17ab5e2262154c17922e27a7163c9a06?pvs=4#39698a50601d4e5c84c1a4580bc20e37
    switch (type) {
        case taxInvoiceStatus.NONE:
        case taxInvoiceStatus.DRAFT:
        case taxInvoiceStatus.PUBLISH_REQUESTED:
            return {
                color: brgChipColorMapper.grey,
                text: i18n.t(`${lc}${typeText}`),
            };
        case taxInvoiceStatus.TRANSFER_IN_PROGRESSED:
        case taxInvoiceStatus.TRANSFER_WAITED:
        case taxInvoiceStatus.TRANSFER_BEFORE:
            return {
                color: brgChipColorMapper.green,
                text: i18n.t(`${lc}${typeText}`),
            };
        case taxInvoiceStatus.TRANSFER_COMPLETED:
        case taxInvoiceStatus.PUBLISH_COMPLETED:
            return {
                color: brgChipColorMapper.blue,
                text: i18n.t(`${lc}${typeText}`),
            };
        case taxInvoiceStatus.TRANSFER_FAILED:
        case taxInvoiceStatus.PUBLISH_REQUEST_REJECTED:
        case taxInvoiceStatus.PUBLISH_REQUEST_CANCELED:
        case taxInvoiceStatus.PUBLISH_REQUEST_FAILED:
        case taxInvoiceStatus.PUBLISH_CANCELED:
            return {
                color: brgChipColorMapper.red,
                text: i18n.t(`${lc}${typeText}`),
            };
        default:
            return null;
    }
};
